import { Close } from "@mui/icons-material";
import { useRef } from "react";
import { toast } from "react-toastify";
import Loading from "../../../utils/Loading";

const FileUploader = ({
  value,
  onChange,
  label = "بارگزاری فایل",
  required = false,
  className = "",
  loading = false,
  showToast = true,
  admin = true,
}) => {
  const fileInputRef = useRef(null);

  const handleClick = () => {
    if (typeof value === "string") {
      window.open(value, "_blank", "noopener,noreferrer");
    } else {
      fileInputRef.current?.click();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange(file);
      showToast && toast.success("فایل با موفقیت اضافه شد");
      e.target.value = "";
    }
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    onChange(null);
    showToast && toast.error("فایل حذف شد");
  };

  return (
    <div
      className={`relative w-full border-2 border-dashed rounded-xl p-8 cursor-pointer transition-all hover:bg-surface-sunken ${
        value && admin
          ? "border-primary bg-primary/5"
          : value && !admin
          ? "border-primary bg-primary/5"
          : "border-primary"
      } ${loading && "pointer-events-none"} ${className}`}
      role="button"
      tabIndex={loading ? -1 : 0}
      aria-label={label}
      aria-disabled={loading}
      onKeyDown={(event) => { if (event.target === event.currentTarget && !loading && (event.key === "Enter" || event.key === " ")) { event.preventDefault(); handleClick(); } }}
      onClick={loading ? undefined : handleClick}
    >
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        required={required}
        style={{ display: "none" }}
      />
      <div className="flex items-center justify-center">
        <div className="text-center text-ink-muted">
          {loading ? (
            <Loading height="18px" width="18px" />
          ) : value ? (
            <>
              <p
                className={`font-medium ${
                  admin ? "text-primary" : "text-primary"
                } max-w-[250px] truncate`}
              >
                {typeof value === "string" ? "فایل آپلود شده" : value.name}
              </p>
            </>
          ) : (
            <span className="text-ink-subtle">{label}</span>
          )}
        </div>

        {value && !loading && (
          <button
            type="button"
            aria-label="حذف فایل انتخاب‌شده"
            onClick={handleRemove}
            className="text-danger hover:text-danger transition-all absolute left-2 top-2"
          >
            <Close className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default FileUploader;
